/* eslint-disable max-lines-per-function */
/* eslint-disable complexity */
import { SubMenuType } from './types';
import { useControllingSubmenuItems } from './useControllingSubmenuItems';
import { useDienstplanSubmenuItems } from './useDienstplanSubmenuItems';
import { useMoreSubmenuItems } from './useMoreSubmenuItems';
import { useProfileSubmenuItems } from './useProfileSubmenuItems';
import { Button, Sheet, SheetContent, SheetTrigger } from '@e2n/ui';
import { useProfile } from '@/hooks';
import {
  faBars,
  faChevronLeft,
  faXmarkLarge,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Transition } from '@headlessui/react';
import { NewsfeedItemsList } from '@/domain/navigation/features/navigation/mobile/MobileMenuItem/NewsfeedItemsList';
import { useMenuItems } from '@/domain/navigation/features/navigation/mobile/MobileMenuItem/useMenuItems';
import { useMitarbeiterSubmenuItems } from '@/domain/navigation/features/navigation/mobile/MobileMenuItem/useMitarbeiterSubMenuItems';

function useSheetHeader(type: SubMenuType) {
  const { t } = useTranslation();
  const profile = useProfile();
  const manager = profile.manager;

  if (type === 'controlling') {
    return t('entities.controlling');
  }

  if (type === 'dienstplan') {
    return t('entities.roster');
  }

  if (type === 'mehr') {
    return t('general.navigation.moreItems');
  }

  if (type === 'profil') {
    return manager.vorname + ' ' + manager.nachname;
  }

  if (type === 'news') {
    return t('general.navigation.profileDropdown.news');
  }

  if (type === 'mitarbeiter') {
    return t('entities.employee_one');
  }

  return '';
}
export function MobileMenuItem() {
  const [isSheetOpen, setIsSheetOpen] = useState(false);
  const [activeSubMenu, setActiveSubMenu] = useState<SubMenuType | null>(null);

  const mainNavItems = useMenuItems({
    setActiveSubmenu: setActiveSubMenu,
    handleClose,
  });
  const controllingSubmenuItems = useControllingSubmenuItems();
  const dienstplanSubmenuItems = useDienstplanSubmenuItems();
  const moreSubmenuItems = useMoreSubmenuItems();
  const profileSubmenuItems = useProfileSubmenuItems({
    handleClose,
    setActiveSubmenu: setActiveSubMenu,
  });

  const mitarbeiterSubmenuItems = useMitarbeiterSubmenuItems({
    handleClose,
    setActiveSubmenu: setActiveSubMenu,
  });

  const sheetHeader = useSheetHeader(activeSubMenu);

  function handleClose() {
    setIsSheetOpen(false);
    setActiveSubMenu(null);
  }

  return (
    <Sheet
      open={isSheetOpen}
      onOpenChange={(open) => {
        if (!open) {
          handleClose();
        } else {
          setIsSheetOpen(true);
        }
      }}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="sm" className="md:hidden p-2">
          <FontAwesomeIcon icon={faBars} />
        </Button>
      </SheetTrigger>
      <SheetContent
        side="right"
        className="w-full p-0 [&>button:first-of-type]:hidden">
        <div className="flex flex-col h-full">
          <div
            className={`flex ${
              activeSubMenu !== null ? 'justify-between' : 'justify-end'
            } items-center p-4 h-16`}>
            {activeSubMenu !== null && (
              <>
                <Button
                  variant="ghost"
                  className="text-neutrals-800"
                  size="icon"
                  onClick={() => setActiveSubMenu(null)}>
                  <FontAwesomeIcon icon={faChevronLeft} />
                </Button>
                <span className="text-sm text-neutrals-800 max-w-28 truncate">
                  {sheetHeader}
                </span>
              </>
            )}
            <Button
              variant="ghost"
              className="text-neutrals-800"
              size="icon"
              onClick={() => handleClose()}>
              <FontAwesomeIcon icon={faXmarkLarge} />
            </Button>
          </div>
          {!activeSubMenu ? (
            <nav className="px-4 flex flex-col gap-4">{mainNavItems}</nav>
          ) : (
            <Transition
              key={activeSubMenu}
              show={activeSubMenu !== null}
              appear
              enter="transition transform duration-300 ease-in-out"
              enterFrom="translate-x-full opacity-0"
              enterTo="translate-x-0 opacity-100"
              leave="transition transform duration-300 ease-in-out"
              leaveFrom="translate-x-0 opacity-100"
              leaveTo="translate-x-full opacity-0">
              <nav className="px-4 flex flex-col gap-4">
                {activeSubMenu === 'controlling' && controllingSubmenuItems}
                {activeSubMenu === 'dienstplan' && dienstplanSubmenuItems}
                {activeSubMenu === 'mehr' && moreSubmenuItems}
                {activeSubMenu === 'profil' && profileSubmenuItems}
                {activeSubMenu === 'news' && (
                  <NewsfeedItemsList handleClose={handleClose} />
                )}
                {activeSubMenu === 'mitarbeiter' && mitarbeiterSubmenuItems}
              </nav>
            </Transition>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}
